/* Indie House draft: canonicalize all Contact links to the supplied /find-us URL.
   This covers Shopify shared menus/page bodies at render time without editing
   live menu records, policy text, email, phone, social or WhatsApp actions. */
(() => {
  if(window.__ihContactDestinationMapped) return;
  window.__ihContactDestinationMapped=true;
  const DESTINATION='https://indieboho.in/find-us';
  const LEGACY_PATHS=new Set(['/pages/contact','/pages/contact-us','/contact','/contact-us']);
  const LABELS=new Set(['contact us','contact','contact the indiehouse team','contact the indie house team','get in touch','get in touch with us']);
  function update(anchor){
    if(!(anchor instanceof HTMLAnchorElement))return;
    const raw=anchor.getAttribute('href')?.trim();
    if(!raw || raw==='#' || raw[0]==='#' || /^(mailto:|tel:|sms:|javascript:|whatsapp:)/i.test(raw))return;
    let url;
    try{url=new URL(raw,document.baseURI)}catch{return}
    if(url.protocol!=='https:'&&url.protocol!=='http:')return;
    const host=url.hostname.toLowerCase();
    const belongs=url.origin===location.origin || host==='indieboho.in' || host==='www.indieboho.in';
    if(!belongs)return;
    const path=url.pathname.replace(/\/+$/,'').toLowerCase();
    const label=(anchor.textContent||anchor.getAttribute('aria-label')||'').replace(/\s+/g,' ').trim().toLowerCase();
    if(LEGACY_PATHS.has(path)||LABELS.has(label)){
      if(anchor.getAttribute('href')!==DESTINATION)anchor.setAttribute('href',DESTINATION);
    }
  }
  function visit(node){
    if(node instanceof HTMLAnchorElement)update(node);
    if(typeof node.querySelectorAll==='function')node.querySelectorAll('a[href]').forEach(update);
  }
  function start(){
    visit(document);
    const observer=new MutationObserver(records=>{
      for(const record of records){
        if(record.type==='attributes'){update(record.target);continue}
        for(const node of record.addedNodes)if(node.nodeType===1)visit(node);
      }
    });
    observer.observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['href']});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();